import React from "react";
import {
  AddCommaNumber,
  AddCommaPhoneNumber,
  getQrPayWithCash,
  getDateWithFormat,
  MaskPhoneNumber,
} from "../../helpers/Utils";
import {
  getInvoiceLogoInfo,
  loadInvoiceFallbackLogoDataUrl,
  waitForInvoiceImage,
} from "../../helpers/InvoiceLogo";
import { Card, CardBody, Row, Table } from "reactstrap";
import classnames from "classnames";
// import { DynamicForm } from './form-dynamic';
import { Colxx, Separator } from "../../components/common/CustomBootstrap";
import moment from "moment";
import SingleLightbox from "../../components/pages/SingleLightbox";
import { GetBank } from "../../helpers/ListBank";
import IntlMessages from "../../helpers/IntlMessages";
import {
  findFeeOther,
  getFeeOtherLabelMessageId,
} from "../../helpers/FeeOtherLabel";
import { getPrintOrderContext } from "../../helpers/PrintOrderContext";
import { getOrderVariantTags } from "../../helpers/OrderVariantLabels";

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fallbackLogoDataUrl: "",
      logoLoadFailed: false,
    };
    this.isMountedComponent = false;
    this.fallbackLogoDataUrlPromise = null;
    this.handleLogoError = this.handleLogoError.bind(this);
  }

  componentDidMount() {
    this.isMountedComponent = true;
    this.prepareForPrint().catch((error) => {
      console.error("Error preparing invoice logo:", error);
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.companyLogo !== this.props.companyLogo &&
      this.state.logoLoadFailed
    ) {
      this.setState({ logoLoadFailed: false });
    }
  }

  componentWillUnmount() {
    this.isMountedComponent = false;
    document.body.classList.remove("noscroll");
  }

  setStateIfMounted(nextState) {
    return new Promise((resolve) => {
      if (!this.isMountedComponent) {
        resolve();
        return;
      }

      this.setState(nextState, resolve);
    });
  }

  loadFallbackLogoDataUrl() {
    if (this.state.fallbackLogoDataUrl) {
      return Promise.resolve(this.state.fallbackLogoDataUrl);
    }

    if (!this.fallbackLogoDataUrlPromise) {
      this.fallbackLogoDataUrlPromise = loadInvoiceFallbackLogoDataUrl()
        .then(async (dataUrl) => {
          if (
            dataUrl &&
            this.isMountedComponent &&
            this.state.fallbackLogoDataUrl !== dataUrl
          ) {
            await this.setStateIfMounted({ fallbackLogoDataUrl: dataUrl });
          }
          return dataUrl || "";
        })
        .catch((error) => {
          console.error("Error loading fallback invoice logo:", error);
          return "";
        });
    }

    return this.fallbackLogoDataUrlPromise;
  }

  async prepareForPrint() {
    const logoInfo = getInvoiceLogoInfo(
      this.props.companyLogo,
      this.state.fallbackLogoDataUrl,
    );

    if (logoInfo.isCustom && !this.state.logoLoadFailed) {
      const loaded = await waitForInvoiceImage(logoInfo.src, "anonymous");
      if (loaded) return;

      if (this.isMountedComponent) {
        await this.setStateIfMounted({ logoLoadFailed: true });
      }
    }

    const fallbackLogoDataUrl = await this.loadFallbackLogoDataUrl();
    const fallbackInfo = getInvoiceLogoInfo("", fallbackLogoDataUrl);
    await waitForInvoiceImage(fallbackInfo.src);
  }

  handleLogoError(event) {
    if (event && event.currentTarget) {
      event.currentTarget.onerror = null;
    }

    if (!this.state.logoLoadFailed) {
      this.setState({ logoLoadFailed: true });
    }

    this.loadFallbackLogoDataUrl().then((dataUrl) => {
      if (dataUrl && event && event.currentTarget) {
        event.currentTarget.src = dataUrl;
      }
    });
  }

  render() {
    // console.log(this.props);
    let {
      items,
      companyName,
      companyAddress,
      companyLogo,
      companyWebsite,
      billDate = getDateWithFormat(),
      discount,
      tax_fee,
      fee_other,
      pin_print = "",
      cardWrapper,
      timeStart,
      customer_name,
      customer_phone,
      customer_address,
      delivery_time,
      table_name,
      print_customer,
      show_order_context,
      mask_phone,
      paymentMethod,
      customer_debt,
      refund_to_customer,
      isChecked,
    } = this.props;

    // Group items with the same name and price
    const consolidatedItems = [];
    if (items && items.length) {
      items.forEach((item) => {
        if (!item) return;
        const productName = item.product && item.product.name ? item.product.name : "";
        const variantSignature = getOrderVariantTags(item).join("|");
        const existing = consolidatedItems.find(
          (g) =>
            g.product &&
            g.product.name === productName &&
            Number(g.price) === Number(item.price) &&
            getOrderVariantTags(g).join("|") === variantSignature,
        );
        if (existing) {
          existing.count += item.count;
        } else {
          consolidatedItems.push({ ...item });
        }
      });
    }
    items = consolidatedItems;

    const displayPinPrint = (() => {
      if (!pin_print) return "";

      // Phân tách ngày linh hoạt để tránh lỗi "Invalid Date"
      const dateToParse = billDate || getDateWithFormat();
      let mDate = moment(dateToParse, "DD/MM/YYYY");
      if (!mDate.isValid()) mDate = moment(dateToParse); // Thử parse tự động nếu format DD/MM/YYYY không khớp
      if (!mDate.isValid()) mDate = moment().utcOffset(7); // Fallback về giờ VN hiện tại

      const prefix = mDate.format("YYMMDD");
      let pinStr = String(pin_print);

      // Nếu pinStr bắt đầu bằng 6 chữ số (có thể là prefix ngày cũ), hãy loại bỏ nó trước khi gắn prefix mới
      // Chỉ loại bỏ nếu nó không khớp với prefix hiện tại ta muốn
      if (/^\d{6}/.test(pinStr) && !pinStr.startsWith(prefix)) {
        pinStr = pinStr.substring(6);
      }

      if (pinStr.startsWith(prefix)) return pinStr;
      if (
        pinStr.includes("+") ||
        pinStr.includes("HĐ") ||
        pinStr.includes("HD")
      )
        return pinStr;
      return `${prefix}${pinStr}`;
    })();

    let total_price = GetTotalPrice(items);
    let total_discount_price = GetTotalDiscountPrice(items, discount);
    let total_tax_fee_price = GetTotalTaxFeePrice(items, tax_fee, discount);
    const total_tax_fee_payable =
      tax_fee && tax_fee.calculation === "included" ? 0 : total_tax_fee_price;
    const providedFeeOther = findFeeOther(fee_other);
    let total_fee_other_price = GetTotalFeeOtherPrice(
      items,
      providedFeeOther,
    );
        let total_payment_price = GetTotalPaymentPrice(
      total_price,
      total_discount_price,
      total_tax_fee_payable,
      total_fee_other_price,
    );

    const resolvedPaymentMethod =
      paymentMethod ||
      this.props.payment_method ||
      (items && items[0]?.payment_method) ||
      "cash";

    const isOrderCredit =
      resolvedPaymentMethod === "credit" ||
      isChecked === true ||
      Boolean(items && items[0]?.payment_method === "credit");

    const currentOrderDebtAmount = isOrderCredit
      ? total_payment_price
      : Number(refund_to_customer || this.props.refund_to_customer) > 0
        ? Number(refund_to_customer || this.props.refund_to_customer)
        : 0;

    const priorDebtAmount =
      Number(
        customer_debt !== undefined
          ? customer_debt
          : this.props.customer_debt !== undefined
            ? this.props.customer_debt
            : this.props.customer?.debt,
      ) || 0;

    const totalDebtRemaining = priorDebtAmount + currentOrderDebtAmount;
    const hasDebtInfo = priorDebtAmount > 0 || currentOrderDebtAmount > 0;

    let paymentMethodLabel = "Tiền mặt";
    if (isOrderCredit) {
      paymentMethodLabel = "Ghi nợ";
    } else if (resolvedPaymentMethod === "transfer") {
      paymentMethodLabel = "Chuyển khoản";
    } else if (resolvedPaymentMethod === "card") {
      paymentMethodLabel = "Thẻ";
    };
    let find_item_discount =
      items &&
      items.find(
        (item) =>
          item &&
          item.discount &&
          (Array.isArray(item.discount)
            ? item.discount.length > 0 && item.discount[0].value
            : item.discount.value),
      );
    let find_item_tax_fee =
      items &&
      items.find(
        (item) =>
          item &&
          item.tax_fee &&
          (Array.isArray(item.tax_fee)
            ? item.tax_fee.length > 0 && item.tax_fee[0].value
            : item.tax_fee.value),
      );
    let find_item_fee_other =
      items &&
      items.find(
        (item) =>
          item &&
          item.fee_other &&
          (Array.isArray(item.fee_other)
            ? item.fee_other.length > 0 && item.fee_other[0].value
            : item.fee_other.value),
      );

    const targetFeeOtherObj =
      providedFeeOther || findFeeOther(find_item_fee_other);
    const hasFeeOtherValue = Boolean(
      targetFeeOtherObj && targetFeeOtherObj.value,
    );

    const shopDefault = "VMASS";
    const addressDefault =
      "380/71 Lê Văn Lương, Phường Tân Hưng, Quận 7, TPHCM";
    // const websiteDefault = 'https://vmass.vn';

    const fullName = localStorage.getItem("fullname");
    const hotline = localStorage.getItem("hotline");
    const namePay = localStorage.getItem("namePay");
    const numberPay = localStorage.getItem("numberPay");
    const bankPay = localStorage.getItem("bankPay");
    const qrPayImage = localStorage.getItem("qrPayImage");
    const timeNow = moment(new Date()).format("HH:mm");

    return !items.length ? (
      <div className="loading" />
    ) : (
      <Row className="invoice-react" id="bill-to-print">
        <Colxx xxs="12" className="mb-4">
          <Card
            className={classnames("mb-5 invoice-contents p-2", {
              card: !cardWrapper,
            })}
            // className='mb-5 invoice-contents'
          >
            <CardBody className="d-flex flex-column justify-content-between p-1">
              <div
                // className='d-flex flex-column'
                className={classnames(
                  "d-flex flex-column align-self-center order-invoice p-0 w-100",
                  {
                    "card-body": !cardWrapper,
                  },
                )}
              >
                <div className="d-flex flex-row justify-content-between pt-2 pb-2">
                  <div className="d-flex align-self-center">
                    <p className="mb-2 text-to-print company-avatar">
                      {(() => {
                        const logoInfo = getInvoiceLogoInfo(
                          this.state.logoLoadFailed ? "" : companyLogo,
                          this.state.fallbackLogoDataUrl,
                        );

                        return (
                          <img
                            alt="VMASS"
                            crossOrigin={
                              logoInfo.isCustom ? "anonymous" : undefined
                            }
                            onError={this.handleLogoError}
                            src={logoInfo.src}
                          />
                        );
                      })()}
                    </p>
                  </div>
                  <div className="d-flex pr-2 text-right align-self-center text-to-print">
                    <div className="text-small text-semi-muted mb-0 text-to-print">
                      <p className="mb-2 text-to-print company-name-invoice">
                        {companyName !== "null" && companyName !== "undefined"
                          ? companyName
                          : shopDefault}
                      </p>
                      <p className="mb-2 text-small text-to-print">
                        {companyAddress !== "null" &&
                        companyAddress !== "undefined"
                          ? companyAddress
                          : addressDefault}
                      </p>
                      <p className="mb-0 text-small text-to-print">
                        {companyWebsite !== "null" &&
                        companyWebsite !== "undefined"
                          ? companyWebsite
                          : null}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-row justify-content-between mb-3">
                  <div className="d-flex flex-column justify-content-center align-items-start w-50 p-2 text-semi-muted bg-area-print">
                    <span className="mb-2 text-small text-to-print">
                      <IntlMessages id="print.cashier" />: {fullName}
                    </span>
                    <span className="text-small text-to-print">
                      Hotline: {hotline}
                    </span>
                  </div>
                  <div className="w-50 d-flex flex-column justify-content-center text-right p-2 text-semi-muted bg-area-print">
                    <span className="mb-2 text-small text-to-print">
                      <IntlMessages id="print.invoice" />: #{displayPinPrint}
                    </span>
                    <span className="mb-2 text-small text-to-print">
                      {billDate}
                    </span>
                    <span className="mb-0 text-small text-to-print">
                      {(() => {
                        if (timeStart && timeStart !== timeNow) {
                          const start = moment(timeStart, "HH:mm");
                          const end = moment(timeNow, "HH:mm");
                          const duration = moment.duration(end.diff(start));
                          const hours = Math.floor(duration.asHours());
                          const minutes = duration.minutes();

                          let durationText = "";
                          if (hours > 0) durationText += `${hours} giờ`;
                          if (minutes > 0) durationText += ` ${minutes} phút`;

                          return (
                            <React.Fragment>
                              {`${timeStart} - ${timeNow}`} <br />
                              {`(${durationText.trim()})`}
                            </React.Fragment>
                          );
                        }
                        return timeNow;
                      })()}
                    </span>
                  </div>
                </div>
                <Separator className="mb-2" />
                <Table borderless>
                  <thead>
                    <style>{`@media print {.no-print{display: none;}}`}</style>
                    <tr>
                      <th className="text-muted pd-light text-extra-small mb-2 text-to-print">
                        #
                      </th>
                      <th className="text-left pd-light text-muted text-extra-small mb-2 text-to-print">
                        <IntlMessages id="print.name-product" />
                      </th>
                      <th className="text-center pd-light text-muted text-extra-small mb-2 text-to-print">
                        <IntlMessages id="print.price" />
                      </th>
                      <th className="text-right pd-light text-muted text-extra-small mb-2 text-to-print">
                        <IntlMessages id="print.total-price" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {items?.length &&
                      items[0] !== null &&
                      items.map((item, idx) => {
                        const variantTags = getOrderVariantTags(item);

                        return (
                          <React.Fragment key={idx}>
                            <tr>
                              <td className="text-to-print pd-light text-primary text-center">
                                {item.count}x
                              </td>
                              <td className="text-to-print pd-light text-left">
                                <div>{item.name || item?.product?.name}</div>
                                {variantTags.length ? (
                                  <div className="text-small text-semi-muted text-to-print">
                                    {variantTags.map((tag, tagIdx) => (
                                      <span key={`${tag}-${tagIdx}`}>
                                        {tagIdx ? " • " : ""}
                                        {tag}
                                      </span>
                                    ))}
                                  </div>
                                ) : null}
                              </td>
                              <td className="text-to-print text-center pd-light">
                                {AddCommaNumber(GetOriginalPrice(item))}
                              </td>
                              <td className="text-right text-to-print pd-light">
                                {AddCommaNumber(item.price * item.count)}
                              </td>
                            </tr>
                            {(discount && discount.saved && discount.note) ||
                            (item.discount && item.discount.note) ? (
                              <tr>
                                <td
                                  className="discount-note no-print pd-light"
                                  colSpan="4"
                                >
                                  {`* ${GetDiscountOrderNote(discount, item)}`}
                                </td>
                              </tr>
                            ) : null}
                          </React.Fragment>
                        );
                      })}
                    {/* {discount &&
                                        discount.saved &&
                                        discount.note ? (
                                            <tr>
                                                <td
                                                    className='discount-note no-print'
                                                    colSpan={5}
                                                >
                                                    {`* Chiết khấu: ${GetDiscountOrderNote(
                                                        discount,
                                                        ''
                                                    )}`}
                                                </td>
                                            </tr>
                                        ) : null}
                                        {tax_fee &&
                                        tax_fee.saved &&
                                        tax_fee.note ? (
                                            <tr>
                                                <td
                                                    className='discount-note no-print'
                                                    colSpan={5}
                                                >
                                                    {`* Thuế phí: ${GetDiscountOrderNote(
                                                        tax_fee,
                                                        ''
                                                    )}`}
                                                </td>
                                            </tr>
                                        ) : null}
                                        {fee_other &&
                                        fee_other.saved &&
                                        fee_other.note ? (
                                            <tr>
                                                <td
                                                    className='discount-note no-print'
                                                    colSpan={5}
                                                >
                                                    {`* Phí khác: ${GetDiscountOrderNote(
                                                        fee_other,
                                                        ''
                                                    )}`}
                                                </td>
                                            </tr>
                                        ) : null} */}
                  </tbody>
                </Table>
              </div>
              <div className="d-flex flex-column">
                <Table borderless className="d-flex justify-content-end mb-2">
                  <tbody>
                    <tr className="font-weight-bold">
                      <td className="text-semi-muted text-to-print text-right pd-light mb-3">
                        <IntlMessages id="print.total-price" />:
                      </td>
                      <td className="text-right text-bold text-to-print pd-light font-weight-bold">
                        {AddCommaNumber(total_price)}
                      </td>
                    </tr>
                    {items[0]?.bill?.shippingOrder && (
                      <tr>
                        <td className="text-semi-muted text-to-print text-right pd-light">
                          <IntlMessages id="print.shipping" /> (
                          {items[0].bill.shippingOrder.provider.toUpperCase()}):
                        </td>
                        <td className="text-right text-to-print pd-light">
                          {items[0].bill.shippingOrder.tracking_code}
                        </td>
                      </tr>
                    )}
                    {(discount &&
                      discount.saved &&
                      discount.value &&
                      discount.type) ||
                    find_item_discount ? (
                      <tr>
                        <td className="text-semi-muted text-to-print text-right pd-light">
                          <IntlMessages id="print.discount" />:
                        </td>
                        <td className="text-right text-to-print pd-light">
                          {AddCommaNumber(total_discount_price)}
                        </td>
                      </tr>
                    ) : null}
                    {(tax_fee &&
                      tax_fee.saved &&
                      tax_fee.value &&
                      tax_fee.type) ||
                    find_item_tax_fee ? (
                      <tr>
                        <td className="text-semi-muted text-to-print text-right pd-light">
                          <IntlMessages id="print.tax" />:
                        </td>
                        <td className="text-right text-to-print pd-light">
                          {AddCommaNumber(total_tax_fee_price)}
                        </td>
                      </tr>
                    ) : null}
                    {hasFeeOtherValue ? (
                      <tr>
                        <td className="text-semi-muted text-to-print text-right pd-light">
                          <IntlMessages
                            id={getFeeOtherLabelMessageId(targetFeeOtherObj)}
                          />:
                        </td>
                        <td className="text-right text-to-print pd-light">
                          {AddCommaNumber(total_fee_other_price)}
                        </td>
                      </tr>
                    ) : null}
                    {(discount &&
                      discount.saved &&
                      discount.value &&
                      discount.type) ||
                    find_item_discount ||
                    (tax_fee &&
                      tax_fee.saved &&
                      tax_fee.value &&
                      tax_fee.type) ||
                    find_item_tax_fee ||
                    hasFeeOtherValue ? (
                      <tr className="font-weight-bold">
                        <td className="text-semi-muted text-to-print text-right pd-light">
                          <IntlMessages id="print.amount-to-pay" />:
                        </td>
                        <td className="text-right text-bold text-to-print pd-light font-weight-bold">
                          {AddCommaNumber(total_payment_price)}
                        </td>
                      </tr>
                    ) : null}

                    {/* <tr className='font-weight-bold'>
                                            <td className='text-semi-muted'>
                                                Total :
                                            </td>
                                            <td className='text-right'>
                                                $ 68.14
                                            </td>
                                        </tr> */}
                                      {/* Hình thức thanh toán */}
                    <tr>
                      <td className="text-semi-muted text-to-print text-right pd-light">
                        Hình thức:
                      </td>
                      <td className="text-right text-bold text-to-print pd-light font-weight-bold">
                        {paymentMethodLabel}
                      </td>
                    </tr>
                    {hasDebtInfo ? (
                      <>
                        {currentOrderDebtAmount > 0 && (
                          <tr>
                            <td className="text-semi-muted text-to-print text-right pd-light text-danger">
                              Nợ đơn này:
                            </td>
                            <td className="text-right text-bold text-to-print pd-light font-weight-bold text-danger">
                              {AddCommaNumber(currentOrderDebtAmount)}
                            </td>
                          </tr>
                        )}
                        {priorDebtAmount > 0 && (
                          <tr>
                            <td className="text-semi-muted text-to-print text-right pd-light">
                              Nợ cũ:
                            </td>
                            <td className="text-right text-to-print pd-light">
                              {AddCommaNumber(priorDebtAmount)}
                            </td>
                          </tr>
                        )}
                        {(priorDebtAmount > 0 || currentOrderDebtAmount > 0) && (
                          <tr className="font-weight-bold">
                            <td className="text-semi-muted text-to-print text-right pd-light text-danger">
                              Tổng nợ còn lại:
                            </td>
                            <td className="text-right text-bold text-to-print pd-light font-weight-bold text-danger">
                              {AddCommaNumber(totalDebtRemaining)}
                            </td>
                          </tr>
                        )}
                      </>
                    ) : null}
                  </tbody>
                </Table>
                {/* Customer Information Section */}
                {(print_customer !== false || show_order_context) && (() => {
                  const {
                    customerName: finalName,
                    customerPhone,
                    customerAddress: finalAddress,
                    deliveryTime: finalDeliveryTime,
                    tableName: finalTableName,
                  } = getPrintOrderContext({
                    items,
                    customerName: customer_name,
                    customerPhone: customer_phone,
                    customerAddress: customer_address,
                    deliveryTime: delivery_time,
                    tableName: table_name,
                  });
                  let finalPhone = customerPhone;

                  if (
                    !finalName &&
                    !finalPhone &&
                    !finalAddress &&
                    !finalDeliveryTime &&
                    !finalTableName
                  ) {
                    return null;
                  }

                  if (mask_phone && finalPhone) {
                    finalPhone = MaskPhoneNumber(finalPhone);
                  }

                  return (
                    <div className="px-0 mb-3 text-to-print">
                      <Separator className="mb-3" />
                      <div style={{ fontSize: "0.65rem", lineHeight: "1.5", textAlign: "left" }} className="text-left">
                        {finalTableName && (
                          <div className="mb-1 text-left" style={{ textAlign: "left" }}>
                            Số bàn: {finalTableName}
                          </div>
                        )}
                        {(finalName || finalPhone) && (
                          <div className="mb-1 d-flex justify-content-between pr-2">
                            {finalName && (
                              <span>
                                Khách hàng: {finalName}
                              </span>
                            )}
                            {finalPhone && (
                              <span>
                                SĐT:{" "}
                                {mask_phone
                                  ? finalPhone
                                  : AddCommaPhoneNumber(finalPhone)}
                              </span>
                            )}
                          </div>
                        )}
                        {finalDeliveryTime && (
                          <div className="mb-1 text-left" style={{ textAlign: "left" }}>
                            Giờ giao: {finalDeliveryTime}
                          </div>
                        )}
                        {finalAddress && (
                          <div className="mb-1 text-left" style={{ textAlign: "left" }}>
                            <span>Địa chỉ: </span>
                            <span className="text-wrap">{finalAddress}</span>
                          </div>
                        )}
                      </div>
                    </div>
                                    );
                })()}

                {/* Chữ ký xác nhận nợ */}
                {currentOrderDebtAmount > 0 && (
                  <div className="text-center mt-3 pt-2 text-to-print" style={{ borderTop: "1px dashed #bbb" }}>
                    <div style={{ fontSize: "12px", fontWeight: "600" }}>Khách hàng ký nhận nợ</div>
                    <div style={{ height: "45px" }} />
                    <div style={{ fontSize: "11px", color: "#666" }}>(Ký và ghi rõ họ tên)</div>
                  </div>
                )}

                {namePay === "null" ||
                numberPay === "null" ||
                bankPay === "null" ||
                // qrPayImage === 'null' ||
                !namePay ||
                !numberPay ||
                !bankPay ? null : ( // ||!qrPayImage
                  <>
                    <Separator className="mb-3" />
                    <div className="d-flex align-items-center mb-2">
                      <Colxx xxs="4" className="pl-0">
                        {bankPay && numberPay ? (
                          <SingleLightbox
                            thumb={getQrPayWithCash(
                              bankPay,
                              numberPay,
                              total_payment_price,
                            )}
                            large={getQrPayWithCash(
                              bankPay,
                              numberPay,
                              total_payment_price,
                            )}
                            className="img-thumbnail card-img-print"
                            crossOrigin="anonymous"
                          />
                        ) : (
                          <h5 className="text-to-print text-center">
                            <IntlMessages id="print.info-bill" />
                          </h5>
                        )}
                      </Colxx>
                      <Colxx xxs="8" className="text-left px-0">
                        <p className="mb-1">{namePay}</p>
                        <p className="mb-1">{numberPay}</p>
                        <p className="mb-1">{GetBank(bankPay).label}</p>
                      </Colxx>
                    </div>
                  </>
                )}
                <div className="border-bottom mb-3" />
                {/* <Separator className='mb-3' /> */}
                {this.props.footerNote && (
                  <p className="invoice-footer-note text-muted text-center mb-1 font-italic">
                    {this.props.footerNote}
                  </p>
                )}
                <p className="text-muted text-small text-center mb-1 mt-3">
                  <IntlMessages id="print.thank-you" />
                </p>
                <span className="text-small text-center">
                  <IntlMessages id="print.copy-right" />
                </span>
              </div>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default ComponentToPrint;

const GetTotalPrice = (items) => {
  if (!items.length) return 0;

  const cost = items.reduce((total, item) => {
    return total + item.price * item.count;
  }, 0);

  return cost;
};

const GetOriginalPrice = (item) => {
  if (!item) return 0;

  return item.price * 1;
};

const GetTotalPaymentPrice = (
  total_price,
  total_price_discount,
  total_price_tax_fee,
  total_price_fee_other,
) => {
  let total_price_val = parseFloat(total_price);
  let total_price_discount_val = parseFloat(total_price_discount);
  let total_price_tax_fee_val = parseFloat(total_price_tax_fee);
  let total_price_fee_other_val = parseFloat(total_price_fee_other);
  let total = 0;

  if (
    !isNaN(total_price_val) &&
    !isNaN(total_price_discount_val) &&
    !isNaN(total_price_tax_fee_val) &&
    !isNaN(total_price_fee_other_val)
  ) {
    total =
      total_price_val -
      total_price_discount_val +
      total_price_tax_fee_val +
      total_price_fee_other_val;
  }

  return total > 0 ? Math.round(total) : 0;
};

const GetDiscountOrderValue = (items, discount, item) => {
  if (!items.length) return 0;

  const reducer = (a, o) => a + o.count;
  const items_count = items.reduce(reducer, 0);

  let price = 0;
  if (discount && discount.saved && discount.value) {
    let discount_value = Math.floor(discount.value);
    if (!isNaN(discount_value)) {
      if (discount.type === "percent") {
        price = discount_value;
      } else if (discount.type === "price") {
        price = (discount_value / items_count) * item.count;
      }
    }
    price = (Math.round(price * 100) / 100).toFixed(1);
  } else if (item.discount) {
    price = item.discount.value;
  }

  return Number(price);
};

const GetDiscountOrderType = (discount, item) => {
  let type = "price";

  if (discount && discount.saved && discount.type) {
    type = discount.type;
  } else if (item.discount) {
    type = item.discount.type;
  }
  return type === "percent" ? "%" : "";
};

const GetDiscountOrderNote = (discount, item) => {
  let note = "";

  if (discount && discount.saved && discount.note) {
    note = discount.note;
  } else if (item.discount) {
    note = item.discount.note;
  }
  return note;
};

const GetTotalDiscountPrice = (items, discount) => {
  if (!items.length) return 0;

  let total_discount = 0;
  for (let i = 0; i < items?.length; i++) {
    let item = items[i];

    // load from create
    if (discount) {
      const discountValue =
        parseFloat(String(discount.value || 0).replace(/\./g, "")) || 0;
      if (discount?.type === "percent") {
        let price_percent = (item?.price * item?.count * discountValue) / 100;
        total_discount = total_discount + parseFloat(price_percent);
      }
      if (discount?.type === "price") {
        total_discount = discountValue;
        break;
      }
    }

    // load from server
    else if (item?.discount) {
      // Handle discount as array (from server hasMany relationship) or object
      const itemDiscount = Array.isArray(item.discount)
        ? item.discount[0]
        : item.discount;
      if (itemDiscount) {
        if (itemDiscount?.type === "percent") {
          let price_percent =
            (item?.price * item?.count * itemDiscount?.value) / 100;
          total_discount = total_discount + parseFloat(price_percent);
        }
        if (itemDiscount?.type === "price") {
          total_discount = total_discount + parseFloat(itemDiscount?.value);
        }
      }
    }
  }

  return Math.round(total_discount);
};

const GetTotalTaxFeePrice = (items, tax_fee, discount) => {
  if (!items || !items.length) return 0;

  const hasManualTax =
    tax_fee &&
    (tax_fee.saved ||
      tax_fee.isManual ||
      (tax_fee.value !== undefined &&
        tax_fee.value !== null &&
        tax_fee.value !== "" &&
        tax_fee.value !== 0 &&
        tax_fee.value !== "0"));

  if (hasManualTax) {
    const taxValue =
      parseFloat(String(tax_fee.value || 0).replace(/\./g, "").replace(",", ".")) || 0;
    if (tax_fee?.type === "percent") {
      let total_tax_fee = 0;
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let price_percent = (item?.price * item?.count * taxValue) / 100;
        total_tax_fee += parseFloat(price_percent);
      }
      return Math.round(total_tax_fee);
    }
    if (tax_fee?.type === "price") {
      return Math.round(taxValue);
    }
  }

  // Helper: tính chiết khấu của 1 item dựa trên discount global hoặc per-item
  const getItemDiscount = (item) => {
    const currentDiscount = discount || (Array.isArray(item?.discount) ? item.discount[0] : item?.discount);
    if (!currentDiscount) return 0;
    const discountValue =
      parseFloat(String(currentDiscount.value || 0).replace(/\./g, "")) || 0;
    if (currentDiscount?.type === "percent") {
      return (item?.price * item?.count * discountValue) / 100;
    }
    if (currentDiscount?.type === "price" && items.length > 0) {
      const totalItemsValue = items.reduce((sum, it) => sum + (it?.price || 0) * (it?.count || 0), 0);
      if (totalItemsValue > 0) {
        return (discountValue * (item?.price * item?.count)) / totalItemsValue;
      }
    }
    return 0;
  };

  let total_tax_fee = 0;
  for (let i = 0; i < items.length; i++) {
    let item = items[i];
    if (item?.tax_fee) {
      const itemTaxFee = Array.isArray(item.tax_fee)
        ? item.tax_fee[0]
        : item.tax_fee;
      if (itemTaxFee) {
        if (itemTaxFee?.type === "percent") {
          let price_percent =
            (item?.price * item?.count * parseFloat(itemTaxFee?.value || 0)) / 100;
          total_tax_fee += parseFloat(price_percent);
        } else if (itemTaxFee?.type === "price") {
          total_tax_fee += parseFloat(itemTaxFee?.value || 0);
        }
      }
    } else {
      const itemTaxRate = parseFloat(
        item?.tax_rate !== undefined
          ? item.tax_rate
          : item?.product?.tax_rate || 0,
      );
      if (itemTaxRate > 0) {
        // Tính thuế trên giá SAU chiết khấu: (price * count - discount) * taxRate / 100
        const itemTotal = (item?.price || 0) * (item?.count || 0);
        const itemDiscountAmt = getItemDiscount(item);
        const postDiscountTotal = Math.max(0, itemTotal - itemDiscountAmt);
        let price_percent = (postDiscountTotal * itemTaxRate) / 100;
        total_tax_fee += parseFloat(price_percent);
      }
    }
  }

  return Math.round(total_tax_fee);
};

const GetTotalFeeOtherPrice = (items, fee_other) => {
  if (!items.length) return 0;

  let total_fee_other = 0;
  for (let i = 0; i < items.length; i++) {
    let item = items[i];

    // load from create
    if (fee_other) {
      const feeValue =
        parseFloat(String(fee_other.value || 0).replace(/\./g, "")) || 0;
      if (fee_other?.type === "percent") {
        let price_percent = (item?.price * item?.count * feeValue) / 100;
        total_fee_other = total_fee_other + parseFloat(price_percent);
      }
      if (fee_other?.type === "price") {
        total_fee_other = feeValue;
        break;
      }
    }

    // load from server
    else if (item && item.fee_other) {
      const itemFeeOther = Array.isArray(item.fee_other)
        ? item.fee_other[0]
        : item.fee_other;
      if (itemFeeOther) {
        if (itemFeeOther.type === "percent") {
          let price_percent =
            (item.price * item.count * itemFeeOther.value) / 100;
          total_fee_other = total_fee_other + parseFloat(price_percent);
        }
        if (itemFeeOther.type === "price") {
          total_fee_other = total_fee_other + parseFloat(itemFeeOther.value);
        }
      }
    }
  }

  return Math.round(total_fee_other);
};
